import { atom } from "jotai";

export const contratosVencidosAtom= atom([]);
export const filtroColaboradorAtom = atom (undefined);
export const filtroFechaFinAtom = atom (null);
export const paginaActualAtom = atom(1);
export const tamanioPaginadoAtom = atom(20);
export const totalRegistrosAtom = atom(0);